import React from "react";
import { Link } from "react-router-dom";

const QRCodeComponent = () => {
  // Retrieve the QR code image URL from localStorage
  const storedQRCode = localStorage.getItem("qr_code_image");

  const acctoken = localStorage.getItem("access_token");

  // Parse the stored QR code since it was saved using JSON.stringify
  const imageSrc = storedQRCode ? JSON.parse(storedQRCode) : null;

  return (
    <>
      <div className="bg-gray-900 backgroundforqr w-full h-[100vh] flex items-center">
        <div className="flex justify-center mx-auto w-full h-[70vh] rounded-xl">
          <div className="z-10 relative flex flex-col justify-center w-full md:w-3/5 p-5 md:px-20 rounded-e-2xl">
            <div className="absolute mx-auto w-[60vw] h-[80vh] -z-10 inset-0 border-2 border-red-600 rounded-xl backdrop-blur-sm bg-red-500/50">
              <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 flex justify-center">
                <img
                  src={require("../../assets/images/commonImages/ZeroMiddleMan Logo 3.png")}
                  alt=""
                  className="bg-white px-4 rounded-2xl w-32 md:w-48"
                />
              </div>
              <div className="flex flex-col items-center py-20 mx-auto">
                <h1 className="text-white pb-2 text-lg font-semibold">
                  Scan this QR code using the Google Authenticator app to
                  receive your authentication code.
                </h1>

                {imageSrc ? (
                  <img
                    src={imageSrc}
                    className="w-[20vw]"
                    alt="QR Code for Google Authentication"
                  />
                ) : (
                  <p>
                    No QR code found or the QR code is invalid. Please generate
                    a new one.
                  </p>
                )}

                <Link
                  className="bg-white px-10 py-2 text-blood font-semibold mt-4 rounded-md hover:bg-blood hover:text-white"
                  to="/twofactorauth"
                >
                  Enter OTP
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QRCodeComponent;
